import React from 'react'

import person from "../../../../../src/assets/images/meetupEvent/picci.png";
import person2 from "../../../../../src/assets/images/meetupEvent/chulboro.png";
import person3 from "../../../../../src/assets/images/meetupEvent/mofiz.png";

const StarComments = () => {
return (
<>
    <div className=" my-3 bg-dark text-light">
        <div className="card-body CommentScroll mx-3 ">

            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person3} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Asaduzzaman
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        How are you bro!{" "}
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person3} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Asaduzzaman
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        How are you bro!{" "}
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person3} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Asaduzzaman
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        How are you bro!{" "}
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person3} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Asaduzzaman
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        How are you bro!{" "}
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person3} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Asaduzzaman
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        How are you bro!{" "}
                    </small>
                </div>
            </div>

            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samsul Haque
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Vai swing er beper tah abar bolen!
                    </small>
                </div>
            </div>
            <div className="d-flex mb-3">
                <img src={person2} alt="" height="40px" width="40px" className="chat-person-name" />
                <div className="live-info">
                    <h6 className="mx-2 my-0  p-0 chat-person-name">
                        Samshu alom
                    </h6>
                    <small className="mx-2 my-0 p-0 text-muted fw-bold">
                        Kops vai! wish me luck
                    </small>
                </div>
            </div>

        </div>
        <div className="card-body mx-3 d-flex ">
            <input type="" name="" placeholder='comment write here' className='p-2 InputComment' />
            <button type="" className='p-2  bg-warning BtnComment'>Submit</button>
        </div>
    </div>
</>
)
}

export default StarComments